const UserManageReducer = (state = {}, action) => {
  switch (action.type) {
    // case "getCompanyListSuccess": {
    //     return Object.assign({}, state, {
    //         CrewList: action.data,
    //     });
    //     break;
    // }//cmt by deepa
    case "getSearchMmplUserSuccess": {
      return Object.assign({}, state, {
        UsersList: action.data,
      });
      break;
    }
    case "gettimezoneListSuccess": {
      return Object.assign({}, state, {
        TimeZoneNameList: action.data,
      });
      break;
    }
    case "getSearchMmplUserFailure": {
      return Object.assign({}, state, {
        UsersList: action.data,
      });
      break;
    }
    case "UserDetails": {
      return Object.assign({}, state, {
        UserDetails: action.data,
      });
      break;
    }
    case "getCompanyListSuccess": {
      return Object.assign({}, state, {
        CompanyList: action.data,
      });
      break;
    }
    case "getshipListSuccess": {
      
      return Object.assign({}, state, {
        ShipNameList: action.data,
      });
      break;
    }
    case "getdeviceListSuccess": {
      return Object.assign({}, state, {
        DeviceList: action.data,
      });
      break;
    }
    case "getUserDetailsSuccess": {
      return Object.assign({}, state, {
        UserInformation: action.data,
      });
      break;
    }
    default: {
      return state;
    }
  }
};
export default UserManageReducer;
